import axios from "axios";
import authHeader from "./auth-Header";
import { showToast } from "./toastServices";

const API_URL = process.env.REACT_APP_API_URL;
const getAllPublicPosts = () => {
  return axios.get(API_URL + "/public");
};

const getAllPrivatePosts = () => {
  return axios.get(API_URL + "/private", { headers: authHeader() });
};

const get = (Link) => {
  return axios.get(API_URL + Link, { headers: authHeader() });
};

const createPost = (URL, formData) => {
  return axios.post(API_URL + URL, formData, { headers: authHeader() });
};

const Post = (URL, formData) => {
  return axios
    .post(API_URL + URL, formData, { headers: authHeader() })
    .then((response) => {
      // Handle successful response
      console.log("response.data.responseCode");
      console.log(response.data.responseCode);
      if (response.data.responseCode === 1) {
        return response.data;
      } else {
        console.log("error,response.data.responseMessage");
        console.log(response.data.responseMessage);
        showToast("error", response.data.responseMessage);
        return;
      }
    })
    .catch((error) => {
      // Handle errors that occurred during the API call
      if (error.response) {
        // The request was made, but the server responded with an error status code.
        console.error("Server responded with an error:", error.response.data);
        console.log("Error response:", error.response.data);

        showToast("error", error.response.data.responseMessage);
      } else if (error.request) {
        // The request was made, but no response was received from the server.
        console.error("No response from the server:", error.request);
        console.log("No response received:", error.request);
        showToast("error", error.message);
      } else {
        // Something else happened that caused an error.
        console.error("Error:", error.message);
        console.log("Error setting up the request:", error.message);
        showToast("error", error.message);
      }
      // You can choose to throw the error again or return a custom error response.
      // For example, you can return an object with an "error" property.
      // return { error: true, message: "An error occurred during the API call." };
      throw error; // Re-throw the error to propagate it to the calling code.
    });
};

const getList = (URL) => {
  return axios
    .get(API_URL + URL, { headers: authHeader() })
    .then((response) => {
      // Handle successful response
      if (response.data.responseCode === 1) {
        return response.data;
      } else {
        showToast("error", response.data.responseMessage);
        return;
      }
    })
    .catch((error) => {
      // Handle errors that occurred during the API call
      if (error.response) {
        // The request was made, but the server responded with an error status code.
        console.error("Server responded with an error:", error.response.data);
        console.log("Error response:", error.response.data);

        showToast("error", error.response.data.responseMessage);
      } else if (error.request) {
        // The request was made, but no response was received from the server.
        console.error("No response from the server:", error.request);
        console.log("No response received:", error.request);
        showToast("error", error.message);
      } else {
        // Something else happened that caused an error.
        console.error("Error:", error.message);
        console.log("Error setting up the request:", error.message);
        showToast("error", error.message);
      }
      // You can choose to throw the error again or return a custom error response.
      // For example, you can return an object with an "error" property.
      // return { error: true, message: "An error occurred during the API call." };
      throw error; // Re-throw the error to propagate it to the calling code.
    });
};

const getWithError = (URL) => {
  return axios
    .get(API_URL + URL, { headers: authHeader() })
    .then((response) => {
      // Handle  response

      return response.data;
    })
    .catch((error) => {
      return error;
      // Handle errors that occurred during the API call
      // if (error.response) {
      //   // The request was made, but the server responded with an error status code.
      //   console.error("Server responded with an error:", error.response.data);
      //   console.log("Error response:", error.response.data);

      //   showToast("error", error.response.data.responseMessage);
      // } else if (error.request) {
      //   // The request was made, but no response was received from the server.
      //   console.error("No response from the server:", error.request);
      //   console.log("No response received:", error.request);
      //   showToast("error", error.message);
      // } else {
      //   // Something else happened that caused an error.
      //   console.error("Error:", error.message);
      //   console.log("Error setting up the request:", error.message);
      //   showToast("error", error.message);
      // }
      // // You can choose to throw the error again or return a custom error response.
      // // For example, you can return an object with an "error" property.
      // // return { error: true, message: "An error occurred during the API call." };
      // throw error; // Re-throw the error to propagate it to the calling code.
    });
};

const Put = (URL, formData) => {
  return axios
    .put(API_URL + URL, formData, { headers: authHeader() })
    .then((response) => {
      // Handle successful response
      console.log("response.data.responseCode");
      console.log(response.data.responseCode);
      if (response.data.responseCode === 1) {
        return response.data;
      } else {
        console.log("error,response.data.responseMessage");
        console.log(response.data.responseMessage);
        showToast("error", response.data.responseMessage);
        return;
      }
    })
    .catch((error) => {
      // Handle errors that occurred during the API call
      if (error.response) {
        // The request was made, but the server responded with an error status code.
        console.error("Server responded with an error:", error.response.data);
        console.log("Error response:", error.response.data);

        showToast("error", error.response.data.responseMessage);
      } else if (error.request) {
        // The request was made, but no response was received from the server.
        console.error("No response from the server:", error.request);
        console.log("No response received:", error.request);
        showToast("error", error.message);
      } else {
        // Something else happened that caused an error.
        console.error("Error:", error.message);
        console.log("Error setting up the request:", error.message);
        showToast("error", error.message);
      }
      // You can choose to throw the error again or return a custom error response.
      // For example, you can return an object with an "error" property.
      // return { error: true, message: "An error occurred during the API call." };
      throw error; // Re-throw the error to propagate it to the calling code.
    });
};

const Delete = (URL) => {
  return axios
    .delete(API_URL + URL, { headers: authHeader() })
    .then((response) => {
      // Handle successful response
      console.log("response.data.responseCode");
      console.log(response.data.responseCode);
      if (response.data.responseCode === 1) {
        return response.data;
      } else {
        console.log("error,response.data.responseMessage");
        console.log(response.data.responseMessage);
        showToast("error", response.data.responseMessage);
        return;
      }
    })
    .catch((error) => {
      // Handle errors that occurred during the API call
      if (error.response) {
        // The request was made, but the server responded with an error status code.
        console.error("Server responded with an error:", error.response.data);
        console.log("Error response:", error.response.data);

        showToast("error", error.response.data.responseMessage);
      } else if (error.request) {
        // The request was made, but no response was received from the server.
        console.error("No response from the server:", error.request);
        console.log("No response received:", error.request);
        showToast("error", error.message);
      } else {
        // Something else happened that caused an error.
        console.error("Error:", error.message);
        console.log("Error setting up the request:", error.message);
        showToast("error", error.message);
      }
      // You can choose to throw the error again or return a custom error response.
      // For example, you can return an object with an "error" property.
      // return { error: true, message: "An error occurred during the API call." };
      throw error; // Re-throw the error to propagate it to the calling code.
    });
};

const APIService = {
  getAllPublicPosts,
  getAllPrivatePosts,
  createPost,
  Post,
  getList,
  getWithError,
  get,
  Put,
  Delete,
};

export default APIService;
